var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"co-popup"},[_c('a-modal',{attrs:{"footer":null,"visible":_vm.visible,"width":_vm.modalWidth.SMALL,"wrapClassName":"contact-popup"},on:{"cancel":_vm.closePopup}},[(_vm.popupEvent === _vm.popupEvents.contact)?_c('ContactSlot',{attrs:{"popupData":_vm.popupData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }